import React, { useEffect, useState } from "react";
import {
  getCurrentDate,
  getCurrentMonthFirstDate,
  getFinancialYearStart,
} from "../../../../Utilitie";
import DayWisePath from "./DayWisePath";
import axios from "axios";
import MonthWisePath from "./MonthWisePath";
import PathController from "./PathController";
import NoDataFound from "../../../../Extra/NoDataFound";
import { LoaderIcon } from "react-hot-toast";
import Loading from "../../../../Extra/Loading";

const sampleState = {
  PT_DATE: false,
  PT_FROM: false,
  PT_TO: false,
  PT_TYPE: false,
  PT_REASON: false,
};
// data,
// setDataForTable,
// setFilteredData,
// openStates,
// setOpenStates,
const PathWastage = () => {
  const [pathData, setPathData] = useState(null);
  const [monthWisePathData, setMonthWisePathData] = useState(null);
  const [filterData, setFilteredData] = useState(null);
  const [dataForTable, setDataForTable] = useState(null);
  const [openStates, setOpenStates] = useState(sampleState);
  const [machineData, setMachineData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const [endDate, setEndDate] = useState(getCurrentDate());
  const fetchMonthWise = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}getPathData?start=${getFinancialYearStart()}&end=${endDate}`
      );
      if (response.data.status === "ok") {
        setMonthWisePathData(response.data.daterange.data);
      }
    } catch (err) {
      console.error("Failed to fetch Path data:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  const fetchPathData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}getPathData?start=${startDate}&end=${endDate}`
      );

      if (response.data.status === "ok") {
        setPathData(response.data.daterange.data);
      }
    } catch (err) {
      console.error("Failed to fetch Path data:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  const fetchMachineData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${urlPrefixBlock}getmachinetype`);
      if (response.data.status === "ok") {
        setMachineData(response.data.machineTypes);
      }
    } catch (err) {
      console.error("Failed to fetch machine types:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMonthWise();
    fetchMachineData();
    fetchPathData();
  }, []);
  return (
    <div
      className=""
      style={{}}
      onClick={() => {
        setOpenStates(sampleState);
      }}
    >
      <div className="papaDiv">
        <div className="d-flex justify-content-between bg-dark text-white p-1 papaDiv">
          <h5 className=""> Path Wastage </h5>
          <div>
            <div className="d-flex  align-items-center ">
              <b>From </b>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="me-1"
              />

              <b>To </b>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
              <button
                className="ms-1 btn btn-sm btn-outline-light"
                onClick={fetchPathData}
              >
                Fetch
              </button>
            </div>
          </div>
        </div>
      </div>

      <div style={{ zIndex: 1 }} className="papaDiv">
        {" "}
        <MonthWisePath data={monthWisePathData} machineData={machineData} />
      </div>
      <div
        className="sticky-controller"
        style={{ zIndex: 3 }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {loading && <Loading />}
        {pathData && (
          <PathController
            data={pathData}
            setFilteredData={setFilteredData}
            setOpenStates={setOpenStates}
            openStates={openStates}
            setDataForTable={setDataForTable}
          />
        )}
      </div>
      <div style={{ zIndex: 1 }}>
        {filterData ? <DayWisePath data={filterData} /> : <NoDataFound />}
      </div>
    </div>
  );
};
export default PathWastage;
